export const DEPARTURE_FULL_LOCATION: Record<string, string> = {
  KUL: "Kuala Lumpur International Airport",
  PEN: "Penang International Airport",
  JHB: "Senai International Airport",
  SIN: "Singapore Changi Airport",
  BKI: "Kota Kinabalu International Airport",
  SZB: "Sultan Abdul Aziz Shah International Airport",
  KCH: "Kuching International Airport",
} as const;

export const EX_END_FULL_LOCATION: Record<string, string> = {
  KUL: "Kuala Lumpur",
  PEN: "Penang",
  JHB: "Johor Bahru",
  SIN: "Singapore",
  BKI: "Kota Kinabalu",
  SZB: "Subang",
  KCH: "Kuching",
} as const;
